/* eslint-disable react-hooks/exhaustive-deps */
import { useMe } from '@Fetcher/index'
import Onboarding from '@Pages/Onboarding'
import { useEffect } from 'react'
import {
  useOnboardingActions,
  useOnboardingState,
} from '@Store/slices/onboarding'
import RouteAwareSkeleton from '@Shared/components/RouteAwareSkeleton'
import { useLocation, useNavigate } from 'react-router'
import EmptyState from '@Pages/EmptyState'
import { STRICT_ONBOARDING_ROUTES } from '@Shared/constants/routes'
import { useCacheActions } from '@Store/slices/cache'
import { useRemoteAppState } from '@Store/slices/remoteApp'

// TODO: Refactor. Onboarding steps are not required on first install. The user can use the app without completing onboarding.
function OnboardingGuard({ children }: { children: JSX.Element }): JSX.Element {
  const [meFetcher, { data: me, isLoading }] = useMe()
  const { pathname, search } = useLocation()
  const { invalidate } = useCacheActions()
  const navigate = useNavigate()
  const { accessToken, refreshToken } = useRemoteAppState()

  const queryParams = new URLSearchParams(search)
  const chargeId = queryParams.get('charge_id')

  const {
    isCompleted,
    isChargeCanceled,
    isOnboardingStarted,
    isOnboardingCanceled,
    isFirstRunLogin,
    menuItemClicked,
    isOnboardingFormSubmitted,
  } = useOnboardingState()
  const {
    setOnboardingCompleted,
    setOnboardingStarted,
    setChargeAccepted,
    setMenuItemClicked,
  } = useOnboardingActions()

  useEffect(() => {
    // useMe -> useBaseFetcher(true) requires BOTH tokens; otherwise base.ts:38
    // throws UnauthorizedError synchronously and crashes the guard tree.
    if (!accessToken || !refreshToken) return
    meFetcher()
  }, [accessToken, refreshToken])

  useEffect(() => {
    setMenuItemClicked(pathname)
  }, [pathname])

  useEffect(() => {
    if (chargeId) {
      setChargeAccepted(true)
      setOnboardingCompleted(true)
      invalidate(['me'])
    }

    if (me && me.is_onboarding_completed !== undefined) {
      if (me.is_onboarding_completed === 0 && isOnboardingStarted) {
        setOnboardingStarted(false)
      }
      if (isCompleted === undefined) {
        setOnboardingCompleted(Boolean(me.is_onboarding_completed))
      }
    }
  }, [me, isCompleted])

  if (isLoading || isCompleted === undefined) {
    return <RouteAwareSkeleton />
  }

  if (chargeId) {
    return children
  }

  if (isOnboardingFormSubmitted) {
    return children
  }

  if (
    menuItemClicked &&
    menuItemClicked !== '/onboarding' &&
    isOnboardingStarted
  ) {
    return <EmptyState path={menuItemClicked} />
  }

  if (!isOnboardingFormSubmitted) {
    if (pathname === '/onboarding') {
      setMenuItemClicked('/onboarding')
      return <Onboarding />
    }
  }

  // App install edildikten sonra ilk onboarding aşamasına başlamak için
  if (isFirstRunLogin && !isCompleted) {
    setMenuItemClicked('/onboarding')
    navigate('/onboarding')
    return <Onboarding />
  }

  if (isCompleted || isOnboardingStarted) return children

  if (isCompleted && isChargeCanceled && isOnboardingStarted) return children

  if (
    STRICT_ONBOARDING_ROUTES.includes(pathname) &&
    !isOnboardingCanceled &&
    !isOnboardingStarted
  ) {
    return <Onboarding />
  }

  return <EmptyState path={pathname} />
}

export default OnboardingGuard
